"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledVideoPlayer = exports.StyledVideo = exports.StyledTitle = exports.StyledTextWrapper = exports.StyledDescription = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("../../fuse-typography-element/src/typography");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledVideoPlayer = exports.StyledVideoPlayer = _styledComponents["default"].div.attrs({
  className: 'fuse-video-player'
}).withConfig({
  displayName: "styled-video-player__StyledVideoPlayer",
  componentId: "sc-1ix9l87-0"
})([""]);
var StyledTextWrapper = exports.StyledTextWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-video-player__text-wrapper',
  'data-testid': 'fuse-video-player-text-wrapper'
}).withConfig({
  displayName: "styled-video-player__StyledTextWrapper",
  componentId: "sc-1ix9l87-1"
})(["gap:var(--spacing-global-space3);display:flex;flex-direction:column;margin-bottom:var(--spacing-global-space7);"]);
var StyledTitle = exports.StyledTitle = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-video-player__title',
  'data-testid': 'fuse-video-player-title'
}).withConfig({
  displayName: "styled-video-player__StyledTitle",
  componentId: "sc-1ix9l87-2"
})(["margin-bottom:0;"]);
var StyledDescription = exports.StyledDescription = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-video-player__video-description',
  'data-testid': 'fuse-video-player-video-description'
}).withConfig({
  displayName: "styled-video-player__StyledDescription",
  componentId: "sc-1ix9l87-3"
})(["margin-bottom:0;"]);
var StyledVideo = exports.StyledVideo = _styledComponents["default"].video.attrs({
  className: 'fuse-video-player__video',
  'data-testid': 'fuse-video-player-video'
}).withConfig({
  displayName: "styled-video-player__StyledVideo",
  componentId: "sc-1ix9l87-4"
})(["display:block;width:100%;aspect-ratio:", ";cursor:pointer;&:focus{outline:unset;}&:focus-visible{outline:var(--spacing-global-space1) solid var(--color-functional-focus);outline-offset:var(--spacing-global-space1);}"], function (_ref) {
  var ratio = _ref.ratio;
  return ratio ? ratio.replace(':', '/') : '16/9';
});